import { axios } from '@/utils/request'

export function getNews (parameter) {
    return axios({
        url: '/news/',
        method: 'get',
        params: parameter
    })
}
